import { render, staticRenderFns } from "./ChannelStatusSynchronizationListView.vue?vue&type=template&id=7b5dc3e5&"
import script from "./ChannelStatusSynchronizationListView.vue?vue&type=script&lang=js&"
export * from "./ChannelStatusSynchronizationListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports